module.exports = __webpack_public_path__ + "e4b0294215288317e83b9091fc82908d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/gb-wls.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/gb-wls.svg
// module chunks = 0